<div class="search-page-container">
  <header class="search-header">
    <div class="header-left">
      <button class="btn-back" (click)="backToDashboard()"><i class="bi bi-arrow-left"></i> Dashboard</button>
      <div class="header-title">
        <h2>Manual Concierge Profile Search</h2>
        <p>Explore verified member profiles across the platform to discover optimal match candidates for your Express subscribers.</p>
      </div>
    </div>
  </header>

  <main class="search-main">
    <!-- Filter Card -->
    <div class="filter-card">
      <div class="filter-row">
        <div class="f-group keyword-group">
          <label>Keyword / Occupation / City</label>
          <div class="input-icon">
            <i class="bi bi-search"></i>
            <input type="text" [(ngModel)]="keyword" (keydown.enter)="onSearch()" placeholder="e.g. Software, Chennai, Doctor..." class="form-control" />
          </div>
        </div>

        <div class="f-group">
          <label>Gender</label>
          <select [(ngModel)]="gender" class="form-select">
            <option value="">Any Gender</option>
            <option value="Male">Bridegroom (Male)</option>
            <option value="Female">Bride (Female)</option>
          </select>
        </div>

        <div class="f-group age-group">
          <label>Min Age</label>
          <input type="number" [(ngModel)]="min_age" placeholder="21" class="form-control" />
        </div>

        <div class="f-group age-group">
          <label>Max Age</label>
          <input type="number" [(ngModel)]="max_age" placeholder="45" class="form-control" />
        </div>

        <div class="f-group btn-group-wrap">
          <label>&nbsp;</label>
          <button class="btn-do-search" (click)="onSearch()" [disabled]="loading">
            <span *ngIf="!loading"><i class="bi bi-search"></i> Search Profiles</span>
            <span *ngIf="loading"><span class="spinner-border spinner-border-sm"></span> Searching...</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Results Grid -->
    <div class="results-section">
      <div *ngIf="loading" class="loading-state">
        <div class="spinner-border text-warning" role="status"></div>
        <p>Querying verified profile database...</p>
      </div>

      <div *ngIf="!loading && profiles.length === 0 && searched" class="empty-results">
        <i class="bi bi-person-x"></i>
        <h3>No Verified Profiles Found</h3>
        <p>Try adjusting your keyword or age range filters above.</p>
      </div>

      <div *ngIf="!loading && profiles.length > 0" class="profiles-grid">
        <div *ngFor="let p of profiles" class="profile-card-rm">
          <div class="card-img">
            <img *ngIf="p.photo_url" [src]="p.photo_url" alt="Member" />
            <div *ngIf="!p.photo_url" class="no-img">{{ p.name.charAt(0) }}</div>
            <span class="match-badge"><i class="bi bi-stars"></i> {{ p.compatibility_score }}% Match</span>
          </div>

          <div class="card-body">
            <h4>{{ p.name }}</h4>
            <p class="sub-info">{{ p.age }} Yrs, {{ p.gender }} • {{ p.caste || 'Member' }}</p>
            <div class="detail-tags">
              <span><i class="bi bi-briefcase"></i> {{ p.occupation }}</span>
              <span><i class="bi bi-geo-alt"></i> {{ p.location }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
